import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './Goal.scss';

import { useEffect, useMemo } from 'react';

import { Helmet } from 'react-helmet';
import Slider from 'react-slick';
import appleStore from '../../assets/images/download-apple-store.svg';
import googlePlay from '../../assets/images/download-google-play.svg';
import espnGoal1 from '../../assets/images/goal-alert-1.webp';
import espnGoal2 from '../../assets/images/goal-alert-2.webp';
import espnGoal3 from '../../assets/images/goal-alert-3.webp';
import espnGoal4 from '../../assets/images/goal-alert-4.webp';
import espnGoal5 from '../../assets/images/goal-alert-5.webp';
import espnGoal6 from '../../assets/images/goal-alert-6.webp';
import topVisual from '../../assets/images/goal-top.webp';
import Header from '../../components/blocks/Header';
import Textblock from '../../components/blocks/Textblock';
import PageLayout from '../../layouts/PageLayout';
import { pageView } from '../../scripts/analytics';

const sliderSettings = {
    autoplay: true,
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 400,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

const Goal = () => {
    useEffect(() => {
        pageView('goal');
    }, []);

    const metaContent = useMemo(() => {
        return {
            meta_title: 'ESPN - Goal!',
            meta_description:
                'Download nu de ESPN Goal! app en mis geen enkel doelpunt.',
            og_title: 'ESPN - Goal! Alle goals in je broekzak!',
            og_site_name: 'ESPN - Goal!',
            og_locale: 'nl_NL',
            og_description:
                'Download nu de ESPN Goal! app en mis geen enkel doelpunt.',
            og_url: window.location.href,
            image: topVisual,
            twitter_title: 'ESPN - Goal!',
            twitter_description:
                'Download nu de ESPN Goal! app en mis geen enkel doelpunt.',
            twitter_image: topVisual,
            twitter_card: 'summary_large_image',
            twitter_site: '@ESPNnl',
            twitter_creator: '@ESPNnl',
        };
    }, [window.location.href]);

    return (
        <PageLayout id="goal">
            {metaContent && (
                <Helmet>
                    <title>{metaContent.meta_title}</title>
                    <meta
                        name="description"
                        property="description"
                        content={metaContent.meta_description}
                    />
                    <meta
                        property="og:title"
                        name="og:title"
                        content={metaContent.og_title}
                    />
                    <meta
                        property="og:site_name"
                        name="og:site_name"
                        content={metaContent.og_site_name}
                    />
                    <meta
                        property="og:description"
                        name="og:description"
                        content={metaContent.og_description}
                    />
                    <meta property="og:type" name="og:type" content="website" />
                    <meta
                        property="og:image"
                        name="og:image"
                        content={metaContent.image}
                    />

                    <meta
                        property="og:url"
                        name="og:url"
                        content={metaContent.og_url}
                    />
                    <meta
                        property="og:locale"
                        name="og:locale"
                        content={metaContent.og_locale}
                    />

                    <meta
                        property="twitter:title"
                        name="twitter:title"
                        content={metaContent.twitter_title}
                    />

                    <meta
                        property="twitter:description"
                        name="twitter:description"
                        content={metaContent.twitter_description}
                    />
                    <meta
                        property="twitter:image"
                        name="twitter:image"
                        content={metaContent.twitter_image}
                    />
                </Helmet>
            )}

            <Header
                image={topVisual}
                title={
                    <>
                        Alle goals in
                        <br />
                        je broekzak!
                    </>
                }
                buttons={[
                    {
                        label: (
                            <img
                                height="40"
                                src={appleStore}
                                alt="Apple Store"
                            />
                        ),
                        link: 'https://apps.apple.com/nl/app/espn-goal/id6472048722',
                        target: 'blank',
                        track: 'compagne:goal:apple-store',
                    },
                    {
                        label: (
                            <img
                                height="40"
                                src={googlePlay}
                                alt="Google Play"
                            />
                        ),
                        link: 'https://play.google.com/store/apps/details?id=com.espn.goalalert',
                        target: 'blank',
                        track: 'compagne:goal:google-play',
                    },
                ]}
                style={{
                    background: `center / cover url(${topVisual}) #ef4135`,
                }}
            />

            <Textblock
                title="Wil je ook elke spits in je broekzak?"
                text={
                    <>
                        Download nu de ESPN Goal! app en mis geen enkel
                        doelpunt.
                    </>
                }
                links={[
                    {
                        label: 'Download in de app store',
                        url: 'https://apps.apple.com/nl/app/espn-goal/id6472048722',
                        target: 'blank',
                    },
                    {
                        label: 'Ontdek het op Google Play',
                        url: 'https://play.google.com/store/apps/details?id=com.espn.goalalert',
                        target: 'blank',
                    },
                ]}
            />
            <div className="container slider-container">
                <Slider {...sliderSettings}>
                    <div>
                        <img
                            className="img-responsive"
                            src={espnGoal1}
                            alt=""
                        />
                    </div>
                    <div>
                        <img
                            className="img-responsive"
                            src={espnGoal2}
                            alt=""
                        />
                    </div>
                    <div>
                        <img
                            className="img-responsive"
                            src={espnGoal3}
                            alt=""
                        />
                    </div>
                    <div>
                        <img
                            className="img-responsive"
                            src={espnGoal4}
                            alt=""
                        />
                    </div>
                    <div>
                        <img
                            className="img-responsive"
                            src={espnGoal5}
                            alt=""
                        />
                    </div>
                    <div>
                        <img
                            className="img-responsive"
                            src={espnGoal6}
                            alt=""
                        />
                    </div>
                </Slider>
            </div>
        </PageLayout>
    );
};

export default Goal;
